import React, { useEffect } from "react";
import Button from "../Button/Button";
import { signInWithGoogle } from "../../firebase/firebase";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import { useSelector } from "react-redux";

export default function LoginOptions() {
  const currentUser = useSelector((state) => state.currentUser.user);

  return (
    <>
      <div className="loginOptions">
        <h1>Inicia sesión para usar la app</h1>
        <Button
          button={{
            type: "login",
            text: "Iniciar sesión con Google",
            icon: faGoogle,
          }}
          onClick={() => signInWithGoogle()}
        />
      </div>
    </>
  );
}
